/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errorfallbackdetailstoggle3Inputs */



/**
* | output |
* | --- |
* | "error details" |
*
* @param {Errorfallbackdetailstoggle3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const errorfallbackdetailstoggle3 = /** @type {((inputs?: Errorfallbackdetailstoggle3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errorfallbackdetailstoggle3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("error details")
	if (locale === "es") return /** @type {LocalizedString} */ ("detalles del error")
	return /** @type {LocalizedString} */ ("подробности ошибки")
});
export { errorfallbackdetailstoggle3 as "errorFallbackDetailsToggle" }